function init_weizhan_overlay() {
    function getByteLen(str) {
        var len = 0;
        for (var i = 0; i < str.length; i++) {
            var ch = str.charCodeAt(i);
            if (ch >= 0 && ch <= 128) {
                len += 1;
            } else {
                len += 2;
            }
        }
        return len;
    }

    // 复杂的自定义覆盖物
    function WeizhanOverlay(point, station_info, data_type, fgcolor, bgcolor, unit, showText) {
      this._point = point;
      this._station_info = station_info;
      this._data_type = data_type
      this._icon = "";
      this.zj_icon = "●"
      var name = station_info.station.Name
      var val = this._data_type === 'wind_direction' ? this._station_info.sensor.direction : this._station_info.sensor[data_type]
      if(typeof val === 'string') {
          val = val || '--'
      } else {
          if(data_type == 'wendu' && val == 0) {

          }else{
            val = colorIntensity.sensortypeRound(data_type, val) || '--'
          }

      }
      let DevType = station_info.path.DevType;
      let icon = this._icon;
      if(DevType === "0") {
        icon = this.zj_icon;
      }
      if (showText) {
        this._text = icon + " " + station_info.station.Name + " " + val + ' ' + unit;
      }else{
        this._text = icon + " " + val + '';
      }
      this._width = 10 + getByteLen(this._text) * 5.5;
      this._fgcolor = fgcolor
      this._bgcolor = bgcolor
    }
    WeizhanOverlay.prototype.station = 'station info'
    WeizhanOverlay.prototype = new BMap.Overlay();
    WeizhanOverlay.prototype.initialize = function (map) {
        this._map = map;
        var div = this._div = document.createElement("div");
        div.style.position = "absolute";
        div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
        div.style.backgroundColor = "#fff";
        div.style.border = "1px solid #333";
        div.style.color = "white";
        div.style.height = "20px";
        div.style.padding = "1px";
        div.style.lineHeight = "20px";
        div.style.whiteSpace = "nowrap";
        div.style.MozUserSelect = "none";
        div.style.fontSize = "12px";
        div.style.borderRadius = "2px";
        div.style.cursor = "pointer";
        div.style.textAlign = "center";
        div.style.width = this._width + "px";
        var div2 = this._div2 = document.createElement("div");
        let v = this._station_info.sensor[this._data_type]
        div2.style.padding = "0 2px 0 2px";
        div2.style.margin = "0";
        div2.style.height = "20px";
        div2.style.borderRadius = "2px";
        div2.style.color= this._fgcolor
        div2.style.background=this._bgcolor
        div.appendChild(div2);
        var span = this._span = document.createElement("span");
        span.style.padding = "0";
        span.style.margin = "0";
        span.appendChild(document.createTextNode(this._text));
        div2.appendChild(span);
        div2.appendChild(document.createTextNode(" "));

        var arrow = this._arrow = document.createElement("div");
        arrow.style.background = "url(static/bmap/label.png) no-repeat";
        arrow.style.backgroundPosition = "0px 0px";
        arrow.style.position = "absolute";
        arrow.style.width = "11px";
        arrow.style.height = "15px";
        arrow.style.top = "22px";
        arrow.style.left = this._width / 2 - 2 + "px";
        arrow.style.overflow = "hidden";
        div.appendChild(arrow);
        map.getPanes().markerPane.appendChild(div);
        return div;
    }
    WeizhanOverlay.prototype.draw = function () {
        var map = this._map;
        var pixel = map.pointToOverlayPixel(this._point);
        this._div.style.left = pixel.x - this._width/2 + "px";
        this._div.style.top = pixel.y - 40 + "px";
    }
    WeizhanOverlay.prototype.addEventListener = function (event, fun) {
        this._div['on'+event] = fun;
    }

    return WeizhanOverlay
}
export default init_weizhan_overlay



// WEBPACK FOOTER //
// ./src/option/overlays.js